import { useEffect } from 'react';
import styled from 'styled-components';

import { CancelRecordFormMeta, CancelRecordFormValues } from 'components/modals/CancelRecordModal';
import ActivityInput from 'components/shared/activityInput/ActivityInput';
import useActivityInput from 'components/shared/activityInput/useActivityInput';
import Button from 'components/shared/Button';
import FieldLabel from 'components/shared/form/FieldLabel';
import { Actions } from 'components/shared/StandardModal';
import { Form, useForm } from 'context/form';

type CancelRecordFormProps = {
  onCancel: () => void;
  locationEpisodeId: string;
};

export default function CancelRecordForm(props: CancelRecordFormProps) {
  const { onCancel, locationEpisodeId } = props;

  const { valid, dirty, meta, setMeta, setValue, values } = useForm<CancelRecordFormValues, CancelRecordFormMeta>();

  const { note, setNote } = useActivityInput({ ...values.note });

  useEffect(() => {
    setValue('note', note);
  }, [note, setValue]);

  return (
    <Form>
      <FormContainer>
        <FieldLabel>Reason for cancelation (optional)</FieldLabel>
        <ActivityInput
          locationEpisodeId={locationEpisodeId}
          values={note}
          setValues={setNote}
          onUploading={(uploading) => setMeta('isUploadingAttachments', uploading)}
        />
      </FormContainer>

      <Actions>
        <Button variant='ghost' type='button' onClick={onCancel}>
          Cancel
        </Button>
        <Button
          type='submit'
          variant='danger'
          disabled={!valid || !dirty || meta.isUploadingAttachments}
          loading={meta.isSubmitting}>
          Confirm Cancelation
        </Button>
      </Actions>
    </Form>
  );
}

const FormContainer = styled.div`
  margin: 20px 0;
`;
